import { useEffect, useState } from "react";
import axios from "axios";
import { CalendarClock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { API, adminApi, formatErr } from "../../lib/api";
import { formatClassAt, toMytInput, fromMytInput } from "../../lib/classDate";

export const ClassDateCard = () => {
  const [current, setCurrent] = useState("");
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/stats`)
      .then(({ data }) => {
        setCurrent(data?.class_at ?? "");
        setValue(toMytInput(data?.class_at ?? ""));
      })
      .catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    if (!value) return;
    setSaving(true);
    try {
      const { data } = await adminApi().put("/admin/settings/class-at", { class_at: fromMytInput(value) });
      setCurrent(data?.class_at ?? "");
      toast.success("Tarikh kelas dikemas kini");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Gagal menyimpan tarikh");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={save} className="glass rounded-2xl p-5 mt-4 max-w-3xl" data-testid="class-date-card">
      <div className="flex items-center gap-2 font-mono text-xs tracking-widest text-violet-200">
        <CalendarClock className="w-4 h-4" /> TARIKH & MASA KELAS
      </div>
      <div className="font-display font-bold text-lg sm:text-xl text-white mt-2" data-testid="class-date-current">
        {current ? formatClassAt(current, "ms") : "-"}
      </div>
      <div className="flex flex-col sm:flex-row gap-3 mt-4">
        <input
          type="datetime-local"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          required
          data-testid="class-date-input"
          className="flex-1 bg-transparent border border-violet-400/30 focus:border-violet-300 rounded-full px-5 py-3 text-base text-white outline-none [color-scheme:dark]"
        />
        <button
          type="submit"
          disabled={saving || !value}
          data-testid="class-date-save-btn"
          className="btn-neon rounded-full px-6 py-3 text-sm font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-50"
        >
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Simpan Tarikh"}
        </button>
      </div>
      <p className="text-xs text-violet-200/75 mt-3">Masa mengikut waktu Malaysia (GMT+8). Countdown di landing page dikemas kini serta-merta.</p>
    </form>
  );
};
